import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { advisorHouseholdUri } from 'Consts/advisorUris';
import LinkItem from '../Item/Link';

const styles = () => ({
  root: {},
});

const SelectedClientItem = ({
  className,
  classes,
  ...rest
}) => {
  const { householdResource } = useSimpleHousehold();
  return (
    <LinkItem
      to={advisorHouseholdUri(householdResource.attr('householdId'))}
      label={`${householdResource.attr('primaryClientFirstName')} ${householdResource.attr('primaryClientLastName')}`}
      isSubLink
      {...rest}
    />
  );
};

SelectedClientItem.defaultProps = {
  className: '',
};

SelectedClientItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectedClientItem);
